import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { TransportEndpoint } from '../../constants/transport-endpoint';
import { TransportCatalogSearchCriteria } from '../../models/transport.model';
import { LoadCatalogStateModel } from '../catalog/load-catalog.state';

@Injectable({
  providedIn: 'root',
})
export class LoadCatalogService {
  constructor(private http: WrapperHttpService) {}

  getLoadCatalog({
    size,
    page,
    ...filter
  }: Partial<TransportCatalogSearchCriteria>): Observable<LoadCatalogStateModel> {
    const url = `${API_URL}${TransportEndpoint.Base}${TransportEndpoint.Loads}`;
    return this.http.withLoading().post<LoadCatalogStateModel>(url, { size, page, filter });
  }
}
